export default {
    title: 'Company-Trends',
    pageTitle: 'ADMIN - COMPANY-TRENDS',
    tabs: {
        0: 'Mega-trends',
        1: 'Macro-trends'
    }
}
